import { Flex, Text, IconButton, Box, Tooltip, Button, HStack } from '@chakra-ui/react'
import { useCallback } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { Trans } from '@lingui/react/macro'

import { useAccount } from '../../hooks/useAccount'
import { colors } from '../../theme/cssVariables'
import { selectUserAvatar } from '../../store/selectors'
import { clearUser } from '../../store/userslice'
import Avatar from '../../components/Avatar'
import LoginButton from '../../components/LoginButton'
import PSkeleton from '../../components/Skeleton'
import GunIcon from '../../components/Icons/GunIcon'
import { useLanguagePath } from '../../hooks/useI18nRoute'
import { ExitIcon } from '../../components/Icons/Icons'
import { selectGemBalance, selectBackpackValues } from '../../store/rushbSelectors'
import RushGemIcon from '../../components/Icons/RushGemIcon'
import { formattedGem } from '../../utils/number'
import { setIsOpenRushSkinsModal } from '../../store/rushbSlice'

const UserLoginBox = () => {
  const { isLogin } = useAccount()
  const avatar = useSelector(selectUserAvatar)
  const balance = useSelector(selectGemBalance)
  const skinsTotal = useSelector(selectBackpackValues)
  const dispatch = useDispatch()

  const onClickGun = useCallback(() => {
    dispatch(setIsOpenRushSkinsModal(true))
  }, [dispatch])

  return (
    <>
      <Flex gap={[2, 2, '30px']} py={4} height={'100%'}>
        {isLogin && (
          <Flex
            justify="space-between"
            align="center"
            gap={[1, 1, 4]}
            fontWeight={700}
            fontSize={'xs'}
          >
            {/* <BorderBox>
              <MessageIcon />
            </BorderBox> */}
            {/* 左侧内容 */}

            <Button
              bg="rgba(255, 255, 255, 0.06)"
              color={colors.colorB2}
              _hover={{}}
              _active={{}}
              as={Flex}
              gap={[2, 2, 5]}
              position={'relative'}
              justifyContent={'space-between'}
              alignItems={'center'}
              minW={'140px'}
              h="fit-content"
              cursor={'auto'}
              py={2}
            >
              <Box height={'inherit'}>
                {/* 子弹信息 */}
                <HStack spacing={2} color={colors.colorA4}>
                  <RushGemIcon width="18px" height="18px" />
                  {balance !== undefined ? (
                    <Text fontSize={'xs'}>{formattedGem(balance)}</Text>
                  ) : (
                    <PSkeleton minH={0} height="12px" width="60px" borderRadius="md" />
                  )}
                </HStack>
                {/* 枪支信息 */}
                <HStack
                  role="group"
                  _hover={{ color: colors.colorA4 }}
                  cursor={'pointer'}
                  onClick={onClickGun}
                  spacing={2}
                >
                  <GunIcon color={'currentColor'} width={'18px'} />
                  {skinsTotal !== undefined ? (
                    <Text fontSize={'xs'}>{formattedGem(skinsTotal)}</Text>
                  ) : (
                    <PSkeleton minH={0} height="12px" width="60px" borderRadius="md" />
                  )}
                </HStack>
              </Box>
            </Button>
            {/* <PromocodeCountDown
              position={'absolute'}
              top={'-20%'}
              right={0}
              fontSize={'9px'}
              py="2px"
              h="fit-content"
              minW="88px"
              countDownMinW="0"
            /> */}
          </Flex>
        )}

        <LoginButton
          minH={'100%'}
          height={'100%!important'}
          variant={isLogin ? 'unstyled' : 'solid'}
          px={'0!important'}
          minW={'unset!important'}
          size={['xs', 'sm', 'md']}
        >
          <Avatar
            url={avatar}
            isShowLevel={false}
            isRelative={true}
            border={`2px solid ${colors.colorA1}`}
            bg={colors.theme}
            padding={'2px'}
          />
        </LoginButton>
      </Flex>
    </>
  )
}

export default UserLoginBox

export const LogOut = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const getPath = useLanguagePath()

  const { removeAuthToken, isLogin, removeUserId } = useAccount()
  const handleLogout = useCallback(async () => {
    try {
      removeAuthToken()
      removeUserId()
      dispatch(clearUser())
      navigate(getPath('/'))
    } catch (e: any) {
      console.error(`Failed to logout: `, e?.message)
    }
  }, [removeAuthToken, navigate, getPath, dispatch, removeUserId])

  if (!isLogin) return null
  return (
    <Tooltip label={<Trans>Logout</Trans>}>
      <IconButton
        aria-label="Logout"
        icon={<ExitIcon size={24} />}
        variant="icon"
        onClick={handleLogout}
      />
    </Tooltip>
  )
}
